/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import type { OperationType } from 'relay-runtime';
import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

type HelpCenterSettingsAnalyticsAppEntryPointComponent = EntryPointComponent<
	Record<string, OperationType>,
	// oxlint-disable-next-line typescript/no-explicit-any
	Record<string, EntryPoint<any, any> | undefined>,
	{},
	{} | null
>;

export const helpCenterSettingsAnalyticsAppEntryPoint: EntryPoint<
	HelpCenterSettingsAnalyticsAppEntryPointComponent,
	{}
> = createEntryPoint({
	root: JSResourceForInteraction<HelpCenterSettingsAnalyticsAppEntryPointComponent>(
		/* webpackChunkName: "async-help-center-settings-analytics-app" */ './HelpCenterSettingAnalyticsApp.tsx',
	),
	getPreloadProps: () => {
		return {};
	},
});
